import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the WishlistHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'wishlist-header',
  templateUrl: 'wishlist-header.html',
  styleUrls: ['./wishlist-header.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class WishlistHeaderComponent {

  text: string;

  constructor(private translateService: TranslateService) {
    this.text = this.translateService.instant('MENU.WISHLIST');
  }

}
